<template>
	<div class="scale-chart-container">
		<canvas id="scale-chart"></canvas>
	</div>
</template>

<script>
import Chart from 'chart.js';

function data() {
	return {
		chartInstance: null,
	};
}

function sortedLevels() {
	return [...this.levels];
}

function chartLabels() {
	return this.sortedLevels.map(l => l.name);
}

function currentSalaries() {
	return this.sortedLevels.map((l) => {
		if (!l.average || l.average === 0) return 0;
		const percentage = l.average / 1000;
		return Math.round(this.currentPayroll * percentage * 100) / 100;
	});
}

function idealSalaries() {
	return this.sortedLevels.map((l) => {
		if (!l.average || l.average === 0) return 0;
		const percentage = l.average / 1000;
		return Math.round(this.idealPayroll * percentage * 100) / 100;
	});
}

function renderChart() {
	const canvas = document.getElementById('scale-chart');
	if (!canvas || this.levels.length === 0) return;
	if (this.chartInstance) {
		this.chartInstance.destroy();
	}
	const hasData = this.sortedLevels.map(l => l.average && l.average > 0);
	const currentColors = hasData.map(d => (d ? '#f09c2b' : 'rgba(158, 158, 158, 0.3)'));
	const idealColors = hasData.map(d => (d ? '#55ac4b' : 'rgba(158, 158, 158, 0.3)'));
	const currentBorders = hasData.map(d => (d ? '#f09c2b' : 'rgba(158, 158, 158, 0.4)'));
	const idealBorders = hasData.map(d => (d ? '#55ac4b' : 'rgba(158, 158, 158, 0.4)'));
	const datasets = [
		{
			label: 'Sueldo Actual',
			data: this.currentSalaries,
			backgroundColor: currentColors,
			borderColor: currentBorders,
			borderWidth: 1,
		},
		{
			label: 'Sueldo Ideal',
			data: this.idealSalaries,
			backgroundColor: idealColors,
			borderColor: idealBorders,
			borderWidth: 1,
		},
	];
	this.chartInstance = new Chart(canvas, {
		type: 'horizontalBar',
		data: {
			labels: this.chartLabels,
			datasets,
		},
		options: {
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				position: 'top',
				labels: {
					fontSize: 12,
					fontStyle: 'bold',
					padding: 20,
					generateLabels: (chart) => {
						const palette = {
							'Sueldo Actual': '#f09c2b',
							'Sueldo Ideal': '#55ac4b',
						};
						return chart.data.datasets.map((ds, i) => {
							const color = palette[ds.label] || '#9e9e9e';
							return {
								text: ds.label,
								fillStyle: color,
								strokeStyle: color,
								lineWidth: 0,
								hidden: !chart.isDatasetVisible(i),
								datasetIndex: i,
							};
						});
					},
				},
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							callback(value) {
								return `$${value.toLocaleString()}`;
							},
						},
						gridLines: {
							display: true,
						},
					},
				],
				yAxes: [
					{
						gridLines: {
							display: false,
						},
						ticks: {
							fontSize: 11,
						},
					},
				],
			},
			tooltips: {
				callbacks: {
					label(tooltipItem) {
						const dsLabel = datasets[tooltipItem.datasetIndex].label;
						const value = tooltipItem.xLabel;
						return ` ${dsLabel}: $${Number(value).toLocaleString()}`;
					},
				},
			},
		},
	});
}

export default {
	name: 'app-table-disenar-escala-grafico',
	props: {
		levels: {
			type: Array,
			default: () => [],
		},
		currentPayroll: {
			type: Number,
			default: 0,
		},
		idealPayroll: {
			type: Number,
			default: 0,
		},
	},
	data,
	computed: {
		sortedLevels,
		chartLabels,
		currentSalaries,
		idealSalaries,
	},
	watch: {
		levels: {
			handler() {
				this.$nextTick(() => this.renderChart());
			},
			deep: true,
		},
	},
	mounted() {
		this.renderChart();
	},
	beforeDestroy() {
		if (this.chartInstance) {
			this.chartInstance.destroy();
		}
	},
	methods: {
		renderChart,
	},
};
</script>

<style lang="scss" scoped>
.scale-chart-container {
	width: 100%;
	max-width: 1032px;
	height: 350px;
	margin: 0 auto;
	padding: 20px 10px;
	border-radius: 9px;
	border: solid 1px #e9e9e9;
	background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/table-disenar-escala/app-table-disenar-escala-grafico.vue